module.exports = __webpack_public_path__ + "static/media/camp-option-vector.a957b0cc.svg";